module.exports = __webpack_public_path__ + "img/logo.f9716445.png";